/* ============================================================================
   LAH — SELOS E PRECO DO CARD ACOMPANHAM A COR CLICADA
   Tema: Outubro (Claude 9.0)

   Ao clicar numa bolinha de cor no card (catalogo e carrossel da home):

     cor esgotada ............ selo "Esgotado"; selo de desconto escondido
     cor com estoque ......... "Esgotado" some
     cor com desconto ........ selo "X% OFF" na cor da faixa; preco DE + PARA
     cor sem desconto ........ selo de desconto escondido; so o preco

   Os valores vem do JSON que o lah-desconto-selo.liquid poe em cada card:
   [preco, preco de comparacao, disponivel]. Nenhuma requisicao.

   FAIXAS: ate 5. A faixa e o numero de limites alcancados, mais 1; limite em
   100% nunca e alcancado, e assim uma faixa fica desligada.

   UM OUVINTE PARA A PAGINA INTEIRA, preso ao documento: vale para cards
   carregados depois (filtros, paginacao). A trava no topo impede que o script,
   incluido por varios cards, rode mais de uma vez.

   PARCELAMENTO: 6x sem juros, centavos arredondados para baixo — mesma regra
   do card no Liquid.
   ============================================================================ */

(function () {
    'use strict';

    if (window.__lahDesconto) return;
    window.__lahDesconto = true;

    function moeda(centavos) {
        return (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    function dados(item) {
        var el = item.querySelector('script[data-lah-precos]');
        if (!el) return null;
        if (el._lahDados !== undefined) return el._lahDados;
        try { el._lahDados = JSON.parse(el.textContent); } catch (e) { el._lahDados = null; }
        return el._lahDados;
    }

    function faixa(pct, d) {
        var f = 1;
        (d.lim || []).forEach(function (l) {
            if (l < 100 && pct >= l) f++;
        });
        return Math.min(f, 5);
    }

    document.addEventListener('change', function (event) {
        var radio = event.target;
        if (!radio.classList || !radio.classList.contains('color-swatch__radio')) return;

        var item = radio.closest('product-item');
        if (!item) return;

        var d = dados(item);
        if (!d || !d.v) return;

        var valores = d.v[radio.getAttribute('data-variant-id')];
        if (!valores) return;

        var preco = valores[0];
        var de = valores[1] || 0;
        var disponivel = valores[2] !== 0;
        var promo = de > preco;
        var pct = promo ? Math.round((de - preco) * 100 / de) : 0;
        /* Claude 21.0: faixa do filtro (31% -> 30%), regra em lah-faixa-desconto */
        if (pct && window.lahFaixaDesc) pct = window.lahFaixaDesc(pct);

        var esgotado = item.querySelector('[data-lah-esgotado]');
        if (esgotado) esgotado.hidden = disponivel;

        var selo = item.querySelector('[data-lah-desc]');
        if (selo) {
            if (promo && disponivel) {
                selo.textContent = pct + '% OFF';
                selo.className = 'lah-desc lah-desc--f' + faixa(pct, d);
                selo.hidden = false;
            } else {
                selo.hidden = true;
            }
        }

        var elPreco = item.querySelector('[data-lah-preco]');
        if (elPreco) {
            elPreco.textContent = moeda(preco);
            elPreco.classList.toggle('lah-card__preco--promo', promo);
        }

        var elDe = item.querySelector('[data-lah-de]');
        if (elDe) {
            if (promo) {
                elDe.textContent = moeda(de);
                elDe.hidden = false;
            } else {
                elDe.hidden = true;
            }
        }

        var elParcela = item.querySelector('[data-lah-parcela]');
        if (elParcela) {
            var n = d.n || 6;
            elParcela.textContent = n + 'x de ' + moeda(Math.floor(preco / n));
        }
    });
})();
